<template>
  <div class="page">
    <navigation></navigation>
  </div>
</template>
<script>
    import Navigation from '../components/common/Navigation.vue';
    export default {
        name: "Video",
        components: {
            Navigation,
        },
    }
</script>
<style scoped lang="scss"></style>
